import { render } from "./RegisterHistoryPage.vue?vue&type=template&id=800201e2&scoped=true&ts=true"
import script from "./RegisterHistoryPage.vue?vue&type=script&lang=ts"
export * from "./RegisterHistoryPage.vue?vue&type=script&lang=ts"

import "./RegisterHistoryPage.vue?vue&type=style&index=0&id=800201e2&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-800201e2"]])

export default __exports__